module.exports = function getResource(label, vars = []) {
    let resources = {
        title: 'Images des commentaires'
    };
    return resources[label];
};
